// ============================================================================
// Doctor Emergency inbox API client.
//
// Backend routes (backend/chatbot/urls.py):
//   GET  /api/chat/emergencies/                       RED cases routed to me
//   POST /api/chat/emergencies/{intentId}/claim/      accept ownership
//
// Coverage-based routing sends RED triage emergencies to the patient's assigned
// clinician, else the Wantok emergency pool. The first doctor to Accept a pool
// case becomes its owner.
// ============================================================================

import { api } from './client.js'

export async function listEmergencies() {
  const { data } = await api.get('/api/chat/emergencies/')
  return data.results || []
}

export async function claimEmergency(intentId) {
  const { data } = await api.post(`/api/chat/emergencies/${intentId}/claim/`)
  return data
}

export async function getEmergencyTranscript(intentId) {
  const { data } = await api.get(`/api/chat/emergencies/${intentId}/transcript/`)
  return data
}

export async function startEmergencyEncounter(intentId) {
  const { data } = await api.post(`/api/chat/emergencies/${intentId}/start-encounter/`)
  return data
}
